import React, { Component } from "react";
import AntDMultipleTextBoxWrapper from "../../../../Components/CustomWrappers/AntDMultipleTextBox";
import AndtDMultiEmailWrapper from "swfrontend/MDM/MDMAntdWrappers/MultipleEmailWrapper";
import AndtDWebsiteWrapper from "swfrontend/MDM/MDMAntdWrappers/WebsiteWrapper";
import { DOMAINS } from "../../../../constants";

class CompanyDetails extends Component {
  render() {
    const { formRef, isDisabled, editDataAvailable, editFormData } = this.props;

    return (
      <div className="row form-box">
        <legend className="form-legend">Company Details</legend>

        <div className="col-lg-6 col-md-12">
          <AndtDWebsiteWrapper
            decorator="company_website"
            id="company_website"
            required={false}
            disabled={isDisabled}
            label="Company Website"
            message="Enter Company Website"
            placeholder="Enter Company Website"
            domainSuggestion={DOMAINS}
            validators=""
            maxlength={241}
            editDataAvailable={false}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDMultiEmailWrapper
            decorator="company_email"
            id="company_email"
            required={false}
            disabled={isDisabled}
            label="Company Email"
            message="Enter Company Email"
            placeholder="Enter Company Email"
            validators=""
            maxlength={241}
            limit={5}
            editFormData={editFormData}
            editDataAvailable={editDataAvailable}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDMultipleTextBoxWrapper
            decorator="company_contactno"
            id="company_contactno"
            required={false}
            disabled={isDisabled}
            label="Company Contact Number"
            message="Enter Company Contact Number"
            placeholder="Enter Company Contact Number"
            validators=""
            maxlength={30}
            editFormData={editFormData}
            editDataAvailable={editDataAvailable}
            formRef={formRef}
          />
        </div>
      </div>
    );
  }
}

export default CompanyDetails;
